import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const ExpandIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 20 20" {...props}>
      <path
        d="M8.93922 11.0606C9.13448 11.2559 9.13448 11.5725 8.93922 11.7677L6.25719 14.4497H9.29277C9.56887 14.4497 9.79264 14.6736 9.79272 14.9497C9.79272 15.2258 9.56892 15.4496 9.29277 15.4496H4.55019L4.55019 10.7071L4.55985 10.6062C4.6065 10.3785 4.8086 10.2072 5.05013 10.2071C5.29171 10.2071 5.49374 10.3785 5.54041 10.6062L5.55008 10.7071L5.55008 13.7426L8.23211 11.0606C8.42733 10.8654 8.74395 10.8655 8.93922 11.0606ZM15.4496 9.29284L15.4399 9.39366C15.3933 9.62149 15.1912 9.79274 14.9496 9.79279C14.708 9.79279 14.506 9.62152 14.4593 9.39366L14.4497 9.29284V6.25725L11.7676 8.93929C11.5724 9.13453 11.2558 9.13451 11.0605 8.93929C10.8653 8.74402 10.8653 8.42744 11.0605 8.23218L13.7426 5.55014L10.707 5.55014C10.4308 5.55014 10.207 5.32634 10.207 5.0502C10.207 4.77406 10.4308 4.55025 10.707 4.55025L15.4496 4.55025V9.29284Z"
        fill={props.fill ?? '#677383'}
      />
    </SvgWrapper>
  );
};
